"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdaptedCustomerAddress = void 0;
var _countryCodes = require("../../utils/countryCodes");
const getAdaptedCustomerAddress = (countryCode, zipCode) => {
  const adaptedZipCode = _countryCodes.requiredZipCountryCodes.includes(countryCode) ? {
    postal_code: zipCode
  } : {};
  return {
    country: countryCode,
    ...adaptedZipCode
  };
};
exports.getAdaptedCustomerAddress = getAdaptedCustomerAddress;